module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }